import React from 'react';
import './LoadingSkeleton.scss';

interface LoadingSkeletonProps {
    width?: string;
    height?: string;
    opacity?: string;
    borderRadius?: string;
    customClassName?: string;
}

export const LoadingSkeleton = ({
    width,
    height,
    opacity,
    borderRadius,
    customClassName,
}: LoadingSkeletonProps) => (
    <span
        style={{ width, height, opacity, borderRadius }}
        className={`skeleton-loader ${customClassName || ''}`}
    />
);
